"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var batch_create_drive_html_1 = __importDefault(require("./batch-create-drive.html"));
var batch_create_drive_controller_1 = __importDefault(require("./batch-create-drive.controller"));
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider
        .state('drivecoach.admin.drives.batchcreate', {
        'url': '/batch-create',
        'controller': batch_create_drive_controller_1.default,
        'controllerAs': 'vm',
        'template': batch_create_drive_html_1.default,
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner
            ]
        }
    });
}
config.$inject = ['$stateProvider', '$urlRouterProvider', 'USER_ROLES'];
exports.default = angular_1.default.module('admin.drives.batchcreate', [])
    .config(config)
    .controller('AdminDrivesBatchCreateController', batch_create_drive_controller_1.default);
